import { GameTicketProperties } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/properties/GameTicketProperties";
/**
 * TicketLandscapeProperties.ts
 */
export class TicketLandscapeProperties extends GameTicketProperties {
    constructor() {
        super();
        this.scale.set(0.73);
        this.position.set(608, 98);
        this.symbolPanelProperties.position.set(131, 131);
    }
}
//# sourceMappingURL=TicketLandscapeProperties.js.map